<template>
  <div v-if="order.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="
          showView &&
          ($permission.permissionAllow('Orders', 'index') ||
            $permission.permissionAllow('Orders', 'approval'))
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="
              ($route.path.startsWith('/orders-approve')
                ? '/#/orders-approve/'
                : '/#/orders/') + order.id
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Order.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 导出订单 -->
      <v-tooltip
        top
        v-if="
          showExport && $permission.permissionAllow('Orders', 'detailExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="orderExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("Order.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("Order.actions.export") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showEdit &&
          order.actions &&
          order.actions.account_edit &&
          $permission.permissionAllow('Orders', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push(
                      ($route.path.startsWith('/orders-approve')
                        ? '/orders-approve/'
                        : '/orders/') +
                        order.id +
                        '/edit'
                    );
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("Order.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("Order.actions.editOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showConfirm &&
          order.actions &&
          order.actions.confirm &&
          $permission.permissionAllow('Orders', 'confirm')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('confirm')
                  : $router.push(
                      ($route.path.startsWith('/orders-approve')
                        ? '/orders-approve/'
                        : '/orders/') +
                        order.id +
                        '/confirm'
                    );
              })
            "
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("Order.actions.confirm") }}
          </v-btn>
        </template>
        <span>{{ $t("Order.actions.confirmOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showRedeliver &&
          order.actions &&
          order.actions.redeliver &&
          $permission.permissionAllow('Orders', 'redeliver')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('redeliver')"
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("Order.actions.redeliver") }}
          </v-btn>
        </template>
        <span>{{ $t("Order.actions.redeliverOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showApprove &&
          order.actions &&
          order.actions.approve &&
          $permission.permissionAllow('Orders', 'approve')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('approve')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{
              $t(
                detailMode
                  ? "Order.actions.approveInDetail"
                  : "Order.actions.approve"
              )
            }}
          </v-btn>
        </template>
        <span>{{ $t("Order.actions.approveOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel &&
          order.actions &&
          order.actions.cancel &&
          $permission.permissionAllow('Orders', 'cancel')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("Order.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("Order.actions.cancelOrder") }}</span>
      </v-tooltip>
      <v-menu
        v-if="
          showPrint &&
          ((order.actions.print &&
            $permission.permissionAllow('Orders', 'orderPrint')) ||
            (order.actions.preprint &&
              $permission.permissionAllow(
                'Orders',
                'orderToDistributionsPrint'
              )) ||
            (false &&
              $permission.permissionAllow('Orders', 'distributionPDFPrint')) ||
            (false &&
              $permission.permissionAllow('Orders', 'distributionWSCPrint')))
        "
        v-model="printBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop=""
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.print") }}
            <v-icon x-small class="ps-1">
              {{ printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="
              order.actions.preprint &&
              $permission.permissionAllow('Orders', 'orderToDistributionsPrint')
            "
            @click.stop="doPrint('distributionPrint')"
          >
            <v-list-item-title>
              {{ $t("Order.actions.distributionPrint") }}
              <span v-if="order.print_count">
                {{ $t("Global.brackets", [order.print_count]) }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="
              false &&
              $permission.permissionAllow('Orders', 'distributionPDFPrint')
            "
            @click.stop="doPrint('distributionPDFPrint')"
          >
            <v-list-item-title>
              {{ $t("Order.actions.distributionPDFPrint") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="
              false &&
              $permission.permissionAllow('Orders', 'distributionWSCPrint')
            "
            @click.stop="doPrint('distributionWSCPrint')"
          >
            <v-list-item-title>
              {{ $t("Order.actions.distributionWSCPrint") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="$permission.permissionAllow('Orders', 'orderPrint')"
            @click.stop="doPrint('OrderPrint')"
          >
            <v-list-item-title>
              {{ $t("Order.actions.orderPrint") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-if="
          showCloudPrint &&
          ((order.actions.print &&
            $permission.permissionAllow('Orders', 'orderPrint')) ||
            (order.actions.preprint &&
              $permission.permissionAllow(
                'Orders',
                'orderToDistributionsPrint'
              ))) &&
          $permission.permissionAllow('CloudPrints', 'index')
        "
        v-model="cloudPrintBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop=""
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.cloud_print") }}
            <v-icon x-small class="ps-1">
              {{ cloudPrintBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="
              order.actions.preprint &&
              $permission.permissionAllow('Orders', 'orderToDistributionsPrint')
            "
            @click.stop="doCloudPrint('distribution')"
          >
            <v-list-item-title>
              {{ $t("Order.actions.distributionPrint") }}
              <span v-if="order.print_count">
                {{ $t("Global.brackets", [order.print_count]) }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="$permission.permissionAllow('Orders', 'orderPrint')"
            @click.stop="doCloudPrint('order')"
          >
            <v-list-item-title>
              {{ $t("Order.actions.orderPrint") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-sheet>
    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('Order.ObjectName')"
      :code="order.order_code"
      @confirm="doAction('cancel')"
    />
    <!-- 批量通过错误提示 -->
    <BatchApproveErrorAlert
      v-model="batchApproveErrorDialog"
      :Items="batchApproveErrorData"
    />
    <!-- 分发出错商品错误提示 -->
    <RedeliverErrorAlert
      v-model="redeliverErrorDialog"
      :Items="redeliverErrorData"
    />
  </div>
</template>

<script>
import DialogDelete from "@/components/plugins/DialogDelete";
import Orders from "@/api/orders";
import BatchApproveErrorAlert from "./BatchApproveErrorAlert";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import makeData from "../../distributions/makeData";
import RedeliverErrorAlert from "./RedeliverErrorAlert";

export default {
  name: "OrderActions",

  components: {
    DialogDelete,
    BatchApproveErrorAlert,
    RedeliverErrorAlert,
  },

  props: {
    order: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showConfirm: Boolean,
    showRedeliver: Boolean,
    showApprove: Boolean,
    showCancel: Boolean,
    showPrint: Boolean,
    showExport: Boolean,
    showCloudPrint: Boolean,
  },

  computed: {},

  data: () => ({
    printBtnMenu: false,
    cloudPrintBtnMenu: false,
    cancelAlert: false,
    batchApproveErrorDialog: false,
    batchApproveErrorData: [],
    redeliverErrorDialog: false,
    redeliverErrorData: [],
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "redeliver") return Orders.redeliver(this.order.id);
      else if (mode == "approve") return Orders.approve(this.order.id);
      else if (mode == "cancel") return Orders.cancel(this.order.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.$store.dispatch("fullscreenLoading");
          this.actionMethod(mode)
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  if (this.detailMode) {
                    // 返回一览页或审核列表页
                    this.$router.push(
                      this.$route.path.startsWith("/orders-approve")
                        ? "/orders-approve"
                        : "/orders"
                    );
                  }
                  this.$emit("done");
                  this.cancelAlert = false;
                } else {
                  if (mode == "approve") {
                    if (response.data.error.code == "ERR668") {
                      this.batchApproveErrorData.push(response.data.data[0]);
                      this.batchApproveErrorDialog = true;
                    }
                  } else if (mode == "redeliver") {
                    this.redeliverErrorData = response.data.data;
                    this.redeliverErrorDialog = true;
                  }
                }
                this.$store.dispatch("fullscreenLoadingStop");
                this.$store.commit("refreshToDos", true);
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$store.commit("refreshToDos", true);
              }.bind(this)
            );
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          switch (mode) {
            case "distributionPrint":
              this.$router.push(
                "/print/order-distribution-print/" + this.order.id
              );
              break;
            case "OrderPrint":
              this.$router.push("/print/order-print/" + this.order.id);
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          let object = null;
          if (mode == "order") {
            //获取单据详情
            Orders.orderPrint(this.order.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  object = response.data.order;
                  CloudPrintTemplates.print({
                    print_template_code: mode,
                    object: object,
                  });
                }
              }.bind(this)
            );
          } else if (mode == "distribution") {
            //获取单据详情
            Orders.orderToDistributionPrint(this.order.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let order = response.data.order;
                  let order_address = response.data.order_address;
                  order.shop = this.$printUtils.addCitiesName(order.shop);
                  if (order.distributions) {
                    order.distributions.forEach((distribution) => {
                      CloudPrintTemplates.print({
                        print_template_code: mode,
                        object: {
                          order: order,
                          distribution: makeData.processDetails(distribution),
                          order_address: order_address,
                        },
                      });
                    });
                  }
                  // object = distributions;
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    orderExport() {
      Orders.detailExports(this.order.id);
    },
  },
  watch: {
    batchApproveErrorDialog: {
      handler() {
        if (!this.batchApproveErrorDialog) {
          this.batchApproveErrorData = [];
        }
      },
    },
  },
};
</script>